import {
  MdBadge,
  MdGroups,
  MdOutlineAccountTree,
  MdVerifiedUser,
} from "react-icons/md";
import { companyInfo, keyPersonnel, organization } from "./RunzeweContent";

const levelIcons = [
  <MdGroups />,
  <MdVerifiedUser />,
  <MdBadge />,
  <MdOutlineAccountTree />,
];

export default function TeamContent() {
  return (
    <>
      <section className="page-hero team-page-hero">
        <div className="page-hero-overlay" />
        <div className="container page-hero-content" data-aos="fade-up">
          <p className="section-kicker">Organization & Team</p>
          <h1>Disciplined Leadership. Dependable Field Teams.</h1>
          <p>
            The company structure connects ownership, board oversight,
            management, supervisors, technical teams, and security guards into a
            clear chain of responsibility.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="section-heading" data-aos="fade-up">
            <p className="section-kicker">Organization Structure</p>
            <h2>Clear command from strategy to the field.</h2>
          </div>

          <div className="org-grid">
            {organization.map((level, index) => (
              <div
                className="org-card"
                key={level.level}
                data-aos="fade-up"
                data-aos-delay={index * 80}
              >
                <div className="org-icon">{levelIcons[index]}</div>
                <h3>{level.level}</h3>
                <ul>
                  {level.people.map((person) => (
                    <li key={person}>{person}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="content-section section-soft">
        <div className="container">
          <div className="section-heading" data-aos="fade-up">
            <p className="section-kicker">Key Personnel</p>
            <h2>Leadership badges ready for official portraits.</h2>
          </div>

          <div className="personnel-grid">
            {keyPersonnel.map((person, index) => (
              <div
                className="personnel-card"
                key={person.name}
                data-aos="zoom-in"
                data-aos-delay={(index % 3) * 80}
              >
                <div className="personnel-photo">
                  <img src={companyInfo.passportImage} alt={person.name} />
                </div>
                <div className="personnel-body">
                  <h3>{person.name}</h3>
                  <strong>{person.role}</strong>
                  <p>{person.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
